import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './components/AuthProvider';

const SKIP_CONSOLE_PATTERNS = [
  /contentscript\.js/i,
  /ObjectMultiplex/i,
];

const _origConsole = { ...console };

['log', 'warn', 'error', 'info', 'debug'].forEach((method) => {
  console[method] = function (...args) {
    const joined = args.map((a) => {
      if (typeof a === 'string') return a;
      if (a instanceof Error) return `${a.name}: ${a.message}\n${a.stack}`;
      try { return JSON.stringify(a); } catch { return String(a); }
    }).join(' ');

    if (SKIP_CONSOLE_PATTERNS.some((re) => re.test(joined))) {
      return;
    }

    const trace = new Error().stack || '';
    if (SKIP_CONSOLE_PATTERNS.some((re) => re.test(trace))) {
      return;
    }

    _origConsole[method].apply(console, args);
  };
});

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: 1,
            cacheTime: 5 * 60 * 1000,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('cirrus_root'));

root.render(
    <QueryClientProvider client={queryClient}>
        <HashRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <React.StrictMode>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </React.StrictMode>
        </HashRouter>
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
